"use client";

import clsx from "clsx";
import { usePathname } from "next/navigation";
import { type OffsetHero_Fields } from "~/__generated__/graphql";
import Container from "~/components/Container";
import HoverArrowLink from "~/components/HoverArrowLink";
import CustomImage from "~/components/CustomImage";
import CustomLink from "~/components/CustomLink";

export default function OffsetHero({
  title,
  image,
  parentPage,
}: OffsetHero_Fields) {
  const pathname = usePathname();

  return (
    <section
      className={clsx(
        "md:min-h-80 z-10 w-full bg-black lg:min-h-[23rem]",
        image && "with-image",
      )}
    >
      <Container containerClass="grid items-center h-full grid-cols-8 gap-6 py-8 lg:grid-cols-12 lg:gap-8">
        <div className="col-span-full col-start-1 flex flex-col justify-around gap-y-6 md:col-span-4 lg:col-span-5 lg:gap-y-0">
          {/* Go back */}
          <CustomLink
            to={pathname?.split("/").slice(0, -1).join("/") + "/"}
            className="group inline-flex items-center text-body text-white opacity-40 hover:opacity-100"
          >
            <>
              <HoverArrowLink
                arrowClass="stroke-white"
                className="mr-2 w-5"
                direction="left"
              />
              {parentPage ?? "Go back"}
            </>
          </CustomLink>
          {/* Title + description */}
          {title && (
            <div>
              <h1 className="text-heading-3 text-white">{title}</h1>
            </div>
          )}
        </div>
        <div className="relative col-span-full col-start-1 md:col-span-4 md:col-start-5 md:self-end lg:col-span-6 lg:col-start-7 lg:block">
          {/* Image */}
          {image && (
            <CustomImage
              data={image}
              priority
              loadingType="eager"
              className="right-0 z-20 w-full object-cover md:top-0 md:h-56 lg:h-84"
              sizes="(min-width: 1280px) calc(50vw - 208px), (min-width: 1040px) calc(50vw - 112px), (min-width: 780px) calc(50vw - 36px), calc(100vw - 48px)"
            />
          )}
        </div>
      </Container>
    </section>
  );
}
